import React__default, { useContext, createContext } from 'react';

const ButtonGroupContext = /*#__PURE__*/createContext({});
const ButtonGroupContextProvider = ({
  name,
  small,
  selectedValue,
  onChange,
  children
}) => /*#__PURE__*/React__default.createElement(ButtonGroupContext.Provider, {
  value: {
    name,
    small,
    selectedValue,
    onChange
  }
}, children);
const useButtonGroupContext = () => useContext(ButtonGroupContext);

export { ButtonGroupContextProvider as B, useButtonGroupContext as u };
//# sourceMappingURL=ButtonGroupContext-Cv5DXHcj.js.map
